import React from 'react';

import { flagStyles } from '../settings';

const SvgNA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3792px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNA;
